import { render, staticRenderFns } from "./dashboardUnidades.vue?vue&type=template&id=215a6b55&"
import script from "./dashboardUnidades.vue?vue&type=script&lang=js&"
export * from "./dashboardUnidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports